var React = require('react');

function FirstInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M226.56 239l194-194a23.84 23.84 0 0 1 33.73-.1l.1.1L477 67.7a24.06 24.06 0 0 1 0 33.85L323.36 256l153.58 154.45a23.87 23.87 0 0 1 .1 33.75l-.1.1-22.65 22.7a23.84 23.84 0 0 1-33.73.1l-.1-.1-193.9-194a24.17 24.17 0 0 1 0-34z","className":"secondary","key":0}),React.createElement("path",{"d":"M35 239L229 45a23.84 23.84 0 0 1 33.73-.1l.1.1 22.61 22.7a23.87 23.87 0 0 1 .1 33.75l-.1.1L131.76 256l153.68 154.45a24.06 24.06 0 0 1 0 33.85L262.79 467a23.84 23.84 0 0 1-33.73.1l-.1-.1L35 273a24.17 24.17 0 0 1 0-34z","className":"primary","key":1})]);
}

FirstInline.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = FirstInline;

FirstInline.default = FirstInline;
